<style>
    table {
        border-spacing: 16px 0;
        border-collapse: separate;
    }
</style>
<table class="mb-3" *ngIf="rates">
    <tr>
        <th>Devise</th>
        <th>Taux (vs EUR)</th>
        <th></th>
    </tr>
    <tr [formGroup]="$any(row)" *ngFor="let row of rates.controls; let i = index">
        <td>
            <mat-form-field appearance="fill">
                <input matInput formControlName="currency" placeholder="USD" style="text-transform: uppercase;">
            </mat-form-field>
        </td>
        <td>
            <mat-form-field appearance="fill">
                <input matInput type="number" step="0.0001" formControlName="rate">
            </mat-form-field>
        </td>
        <td>
            <button mat-icon-button type="button" class="red-colored" (click)="removeRow(i)">
                <mat-icon>delete</mat-icon>
            </button>
        </td>
    </tr>
</table>
<button mat-raised-button type="button" class="m-2" (click)="addRow()">
    <mat-icon>add</mat-icon> Ajouter une devise
</button>
<p class="red-colored" *ngIf="rates?.errors?.duplicateCurrency">
    Une même devise ne peut être renseignée qu'une seule fois.
</p>
